import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { SQUARE_INITIATE_PAYMENT } from '../../../../../constants/square-endpoints.constant';

function SquareAch(props) {
    const [idempotentKey, setIdempotentKey] = useState(uuidv4());
    const [ach, setAch] = useState();
    const tokenize = async (paymentMethod,options = {}) => {
        paymentMethod.addEventListener(
            'ontokenization',
            async function (event) {
                const { tokenResult, error } = event.detail;
                if (error !== undefined) {
                    let errorMessage = `Tokenization failed with error: ${error}`;
                    props?.setErrorMessage(errorMessage);
                    return;
                }
                if (tokenResult?.status === 'OK') {
                    props?.setLoading(true);
                    const donationPayload = props?.returnDonationPayload();
                    donationPayload.payment_method_id = tokenResult.token;
                    donationPayload.payment_type = 'Card';
                    donationPayload.isACH = true;
                    donationPayload.idempotent_key = idempotentKey;
                    const response = await axios.post(SQUARE_INITIATE_PAYMENT, donationPayload);
                    props?.setLoading(false);
                    if (response?.data.status === false) {
                        props?.setErrorMessage(response?.data?.message);
                    } else {
                        props?.onPaymentSuccess("Payment successful thank you for your kind donations.");
                    }
                } else {
                    props?.setLoading(false);
                    let errorMessage = `Tokenization failed with status: ${tokenResult.status}`;
                    if (tokenResult.errors) {
                        errorMessage += ` and errors: ${JSON.stringify(
                            tokenResult.errors,
                        )}`;
                    }
                    props?.setErrorMessage(errorMessage);
                }
            },
        );
        await paymentMethod.tokenize(options);
    }

    async function handlePaymentMethodSubmission(
        event,
        paymentMethod
    ) {
        event.preventDefault();

        try {
            const payload = props?.returnDonationPayload();
            await tokenize(paymentMethod, {
                accountHolderName: `${payload?.first_name} ${payload?.last_name}`,
                intent: 'CHARGE',
                amount: payload?.amount?.toString(),
                currency: props?.campaignDetail?.currency?.toUpperCase(),
            });
        } catch (e) {
            console.error(e.message);
        }
    }

    const initiateACH = async () => {
        const ach = await props?.squareInstance.ach({
            redirectURI: window.location.href,
            transactionId: idempotentKey,
        });
        setAch(ach);
    }

    useEffect(() => {
        if(props?.squareInstance && idempotentKey){
            initiateACH();
        }
    }, [props?.squareInstance, idempotentKey])

    return (
        <>
        <button  style={{
              backgroundColor: props?.campaignDetail?.primary_color ? (props?.campaignDetail?.primary_color) : '#005B97',
              borderBottom: props?.campaignDetail?.primary_color ? ('2px solid ' + props?.campaignDetail?.primary_color) : ''
            }} type='button' onClick={(event) => {
            handlePaymentMethodSubmission(event, ach);
        }} className="btn btn-primary w-100 align-items-center">
            <span>
            <i className="fa-solid fa-building-columns mx-2 p-2"></i>Direct Bank Transfer
            </span>
        </button>
        {
                props?.errorMessage ?
                    <p className='text-danger'>{props?.errorMessage}</p>
                    : ''
            }
        </>
        
        
    );
}

export default SquareAch;